import { connect } from 'react-redux'
import Permissions from './permissions'
import { fetchChildren } from '../../../../stores/children/children.actions'
import {
  searchSchoolsToRequest,
  connectToStudent
} from '../../../../stores/user/user.actions'
import {
  getFetchChildrenRequest,
  getChildrenList
} from '../../../../stores/children/children.selectors'
import { errorHandler } from 'pobble-components/dist/error-handler'
import { toast } from 'pobble-components/dist/toast'

const mapStateToProps = state => ({
  pending: getFetchChildrenRequest(state).pending,
  children: getChildrenList(state) || []
})

const mapDispatchToProps = dispatch => ({
  onMount: () => dispatch(fetchChildren()).catch(errorHandler),
  onSearchChange: term =>
    dispatch(searchSchoolsToRequest(term)).catch(errorHandler),
  onSubmit: values =>
    dispatch(
      connectToStudent(values.schoolId, { code: values.parentCode })
    ).catch(() =>
      toast.error(
        'This code is not valid. Please ask you child’s teacher if you need one.'
      )
    )
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Permissions)
